module.exports = __webpack_public_path__ + "c27f57d1cbb9d6b57d82d05c7f634808.jpg";